import PubSub from 'pubsub-js';
import Swiper from 'swiper';
import { TimelineMax } from 'gsap/TweenMax';
import { EVENTS } from '@/scripts/constants';

export default () => {
  const tl = new TimelineMax();
  const selector = '[data-role="cover-slider-stagger"]';
  tl.set(selector, { autoAlpha: 0 });
  const sliderEl = document.querySelector('[data-role="cover-slider"]');
  PubSub.subscribe(EVENTS.preloaderEnd, () => {
    tl.staggerTo(selector, 0.5, { autoAlpha: 1 }, 0.1);
  });
  const lineInner = document.querySelector('.cover-slider__line-inner');
  if (lineInner) {
    lineInner.classList.add('active');
  }
  let firstImageLoaded = false;
  new Swiper(sliderEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    preloadImages: false,
    simulateTouch: false,
    grabCursor: false,
    lazy: {
      loadPrevNext: true,
    },
    pagination: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 800,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: false,
    },
    on: {
      lazyImageReady() {
        if (!firstImageLoaded) {
          PubSub.publish('coverSliderReady');
          firstImageLoaded = true;
          this.autoplay.start();
        }
      },
      slideChangeTransitionStart() {
        tl.to(selector, 0.3, { autoAlpha: 0, x: -30 });
        const currentSlideNum = document.querySelector('.cover-slider__current-index');
        const sindex = $('.swiper-slide-active').data('swiper-slide-index');
        const currentNum = sindex + 1;
        currentSlideNum.innerText = `0${currentNum}`;
        // TweenMax.fromTo(el, 5, { y: '100%' }, { y: 0 });
        if (this.autoplay.running) {
          lineInner.classList.remove('active');
        }
      },
      slideChangeTransitionEnd() {
        tl.staggerFromTo(
          $(sliderEl).find(`.swiper-slide-active ${selector}`), 0.5,
          { autoAlpha: 0, x: 0, y: -15 },
          { autoAlpha: 1, y: 0 },
          0.1,
        );
        if (this.autoplay.running) {
          lineInner.classList.add('active');
        }
      },
    },
  });
};



// WEBPACK FOOTER //
// ./scripts/initCoverSlider.js